module.exports = __webpack_public_path__ + "static/media/glacier-garden.9bedd140.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/small/glacier-garden.png
 ** module id = 192
 ** module chunks = 0
 **/